module.exports = __webpack_public_path__ + "img/61e12a7.jpg";